export default __webpack_public_path__ + "static/media/photo-1507003211169-0a1dd7228f2d.63bee4f7.jpeg";